<template>
  <div class="Cwarp">
    <div class="Chead">
      <div class="left-icon" @click="clickChangeLang">
        <b>中</b>/<span class="mecity">EN</span>
      </div>
      <div class="center-title">
        <span class="mecity">MECITY</span>
      </div>
      <div class="right-icon" @click="clickChangeType">
        <transition name="img-show">
          <img v-if="isShowMenu" class="close-icon" src="@/assets/images/close.png">
        </transition>
        <transition name="img-show">
          <img v-if="!isShowMenu" class="menu-icon" src="@/assets/images/menu.png">
        </transition>
      </div>
    </div>
    <div class="Cbody">
      <div class="Cbody-inner">
        <slot />
        <Menu :isShowMenu="isShowMenu" />
      </div>
    </div>
    <div class="Cfoot">
      <div>COPYRIGHT ©️ 2000-2021</div>
      <div>版权所有 上海美特斯邦威服饰股份有限公司</div>
      <div><a href="http://beian.miit.gov.cn" target="_blank">沪ICP备05033127号-1</a></div>
      <div class="otherlink beian">
        <a href="http://beian.miit.gov.cn" target="_blank">
          <img src="//s.banggo.com/pub1/bgweb/default/images/lz_beian_h40.png" width="136" height="40" alt="网站备案信息"
            style="display: block" />
        </a>
      </div>
      <div class="otherlink">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502011592" target="_blank">
          <img class="fl" src="https://pic.metersbonwe.com/sources/images/mb/beian.png" />
          <p class="fl">&nbsp; 沪公网安备 31011502011592号</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '../../component/menu'
export default {
  data() {
    return {
      isShowMenu: false,
      langType: 'us'
    }
  },
  components: {
    Menu
  },
  methods: {
    clickChangeType() {
      const isShowMenu = this.isShowMenu
      this.isShowMenu = !isShowMenu
      if (!isShowMenu) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }
    },
    clickChangeLang() {
      this.$i18n.locale = this.$i18n.locale === 'cn' ? 'us' : 'cn'
    }
  }
}
</script>
<style lang="less" scoped>
  .Cwarp {
    height: 100%;
  }

  .Chead {
    height: 60px;
    background: #fff;
    font-size: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // position: relative;
    padding: 0 10px;

    .left-icon {
      font-size: 14px;
    }

    .right-icon {
      width: 25px;
      height: 100%;
      position: relative;

      img {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background: #fff;
      }

      .img-show-enter-active {
        transition: all .6s ease;
        z-index: 1;
      }

      .img-show-leave-active {
        transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
      }

      .img-show-enter,
      .img-show-leave-to {
        right: -100%;
      }
    }

    .menu-icon {
      width: 22px;
      height: 25px;
    }
  }

  .Cfoot {
    width: 100%;
    background: #fff;
    text-align: center;
    line-height: 20px;
    padding-bottom: 4px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: black;
    }

    .otherlink {
      margin: 0 6px;
      font-size: 12px;
      display: flex;
      align-items: baseline;
      justify-content: center;
    }

    .beian {
      margin-top: 10px;
    }
  }
</style>
